/**
 * @flow
 * @relayHash ad6a50a50115e4e6539da7bba9c692ad
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type MMLeaderboardResult_getLeaderboardPositions$ref = any;
export type MMLeaderboardResultRefetchQueryVariables = {|
  event_id: number,
  segment_id?: ?number,
  page_number?: ?number,
  rec_per_page?: ?number,
  searchInput?: ?string,
|};
export type MMLeaderboardResultRefetchQueryResponse = {|
  +$fragmentRefs: MMLeaderboardResult_getLeaderboardPositions$ref
|};
export type MMLeaderboardResultRefetchQuery = {|
  variables: MMLeaderboardResultRefetchQueryVariables,
  response: MMLeaderboardResultRefetchQueryResponse,
|};
*/


/*
query MMLeaderboardResultRefetchQuery(
  $event_id: Int!
  $segment_id: Int
  $page_number: Int
  $rec_per_page: Int
  $searchInput: String
) {
  ...MMLeaderboardResult_getLeaderboardPositions_P2a6N
}

fragment MMLeaderboardResult_getLeaderboardPositions_P2a6N on Query {
  getLeaderboardPositions(event_id: $event_id, segment_id: $segment_id, page_number: $page_number, rec_per_page: $rec_per_page, searchInput: $searchInput) {
    code
    message
    data {
      points
      position
      guest {
        guest_name
        guest_title
      }
    }
    max_page
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "event_id",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "segment_id",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "page_number",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "rec_per_page",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "searchInput",
    "type": "String",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "event_id",
    "variableName": "event_id"
  },
  {
    "kind": "Variable",
    "name": "page_number",
    "variableName": "page_number"
  },
  {
    "kind": "Variable",
    "name": "rec_per_page",
    "variableName": "rec_per_page"
  },
  {
    "kind": "Variable",
    "name": "searchInput",
    "variableName": "searchInput"
  },
  {
    "kind": "Variable",
    "name": "segment_id",
    "variableName": "segment_id"
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "MMLeaderboardResultRefetchQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "MMLeaderboardResult_getLeaderboardPositions",
        "args": (v1/*: any*/)
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "MMLeaderboardResultRefetchQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "getLeaderboardPositions",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "leaderboard_positions",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "code",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "message",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "data",
            "storageKey": null,
            "args": null,
            "concreteType": "positions",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "points",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "position",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "guest",
                "storageKey": null,
                "args": null,
                "concreteType": "front_inner_events_guest",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "guest_name",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "guest_title",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "max_page",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "MMLeaderboardResultRefetchQuery",
    "id": null,
    "text": "query MMLeaderboardResultRefetchQuery(\n  $event_id: Int!\n  $segment_id: Int\n  $page_number: Int\n  $rec_per_page: Int\n  $searchInput: String\n) {\n  ...MMLeaderboardResult_getLeaderboardPositions_P2a6N\n}\n\nfragment MMLeaderboardResult_getLeaderboardPositions_P2a6N on Query {\n  getLeaderboardPositions(event_id: $event_id, segment_id: $segment_id, page_number: $page_number, rec_per_page: $rec_per_page, searchInput: $searchInput) {\n    code\n    message\n    data {\n      points\n      position\n      guest {\n        guest_name\n        guest_title\n      }\n    }\n    max_page\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '4b5b05e67d56b29340500ae410261b86';
module.exports = node;
